import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Vérifié / conforme — bouclier + check duotone */
export const VerifiedIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Bouclier menthe */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Contour bleu */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Check */}
      <path
        d="M9 12l2 2 4-4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
VerifiedIcon.displayName = "VerifiedIcon";
